<template>
    <div class="no-agent-wrapper">
        <div class="no-agent-icon-wrapper">
            <icon-no-preferred-agent />
        </div>
        <div class="no-agent-text">{{ $t("message.noPreferredAgent") }}</div>
        <button class="no-agent-button" @click="openSelectModal()">{{ $t("message.toPrefer") }}</button>
    </div>
</template>
<script>
import IconNoPreferredAgent from "./icons/IconNoPreferredAgent.vue";
export default {
    name: "NoPreferredAgent",
    components: {
        IconNoPreferredAgent,
    },
    methods: {
        openSelectModal() {
            this.$emit("openSelectModal");
        },
    },
};
</script>
<style>
.no-agent-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    padding: 20px;
    .no-agent-text {
        font-family: "Poppins", sans-serif;
        font-size: 16px;
        color: #8796af;
        margin: 10px 0;
    }
    .no-agent-button {
        background-color: #f1f4f7;
        color: black;
        border: none;
        padding: 10px 20px;
        border-radius: 30px;
        cursor: pointer;
        font-size: 16px;
        transition: 0.3s;
        margin-top: 20px;
        font-weight: bold;
        &:hover {
            background-color: #3e7cb1;
            color: white;
        }
    }
}
</style>
